import { authApi } from '../api/insolita';

const TOKEN_KEY = 'authToken';
const ROLE_KEY = 'authRole';
const NAME_KEY = 'authName';

export async function adminLogin(email: string, password: string): Promise<void> {
  const res = await authApi.login(email, password);
  localStorage.setItem(TOKEN_KEY, res.token);
  localStorage.setItem(ROLE_KEY, res.role);
  localStorage.setItem(NAME_KEY, `${res.name} ${res.surname}`.trim());
}

export function adminLogout(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ROLE_KEY);
  localStorage.removeItem(NAME_KEY);
}

export function isAuthenticated(): boolean {
  return !!localStorage.getItem(TOKEN_KEY);
}

export function adminName(): string {
  return localStorage.getItem(NAME_KEY) || 'Admin';
}
